module.exports = __webpack_public_path__ + "img/client-roles.ab2ce34a.svg";